import axios from 'axios';
import { getAPIUrl } from '../config/config';
import { getUser, logout } from './authService';
import { isExternalDomain } from '../utils';

const instance = axios.create({
  baseURL: getAPIUrl(),
});

instance.interceptors.request.use(
  async (config) => {
    const user = getUser();

    if (user && config.headers && !isExternalDomain(config.url!)) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${user.access_token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // should logout user as the data is forbidden
    if (error.response.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);

export default instance;
